import { createSelector } from '@reduxjs/toolkit';
import { IApplicationState } from 'shared/types/redux';

export const selectRedirectInfoForAuth = createSelector(
  (state: IApplicationState) => state.landing.authorizedModal,
  authorizedModal => ({
    pathForRedirect: authorizedModal.pathForRedirect,
    typeForRedirect: authorizedModal.typeForRedirect,
    bankName: authorizedModal.bankName,
    targetElementForRedirect: authorizedModal.targetElementForRedirect,
  }),
);
